export default __webpack_public_path__ + "assets/img/ict-color.9a9561f2b9a9144b46acb1a7b8699ec8.svg";